import {BaseService} from './base'


class HosService extends BaseService {
    constructor() {
        super();
    }

    /**
     *  获取所有省，市，区的列表
     *
     * */
    async getArea(data) {
        const {code, obj = {}} = await this.$http('smarthos.system.area.list', data);
        return code === '0' ? obj : {};
    }
    async getAllArea(data) {
        const {code, obj = []} = await this.$http('smarthos.system.area.list.third', data);
        return code === '0' ? obj : [];
    }
    /**
     *  获取医院id下的检查项目
     *
     * */
    async getInspectList(data){
        const {code, list = []} = await this.$http('smarthos.referral.inspect.list', data);
        return code === '0' ? list : [];
    }

    /**
     *  获取医院id下的手术项目
     *
     * */
    async getSurgeryList(data){
        const {code, list = []} = await this.$http('smarthos.referral.operation.list', data);
        return code === '0' ? list : [];
    }

    /***
     *  申请转诊医助医
     *
     */
    async ass(data){
        const {code} = await this.$http('smarthos.referral.order.ass.issue', data);
        return code === '0';
    }

    /***
     *  申请转诊医医
     *
     */
    async doc(data){
        const {code} = await this.$http('smarthos.referral.order.doc.issue', data);
        return code === '0';
    }

    /**
     *  查询转诊列表--发起方
     *
     * */
    async initList(data){
        const {code, list = [],page} = await this.$http('smarthos.referral.order.init.list', data);
        return code === '0' ? {list,page} : {list:[],page};
    }

    /**
     *  查询转诊列表--接收方
     *
     * */
    async acceptList(data){
        const {code, list = [],page} = await this.$http('smarthos.referral.order.accept.list', data);
        return code === '0' ? {list,page} : {list:[],page};

    }

    /***
     *  根据转诊单号码查询转诊详情
     */
    async queryDetail(data){
        const {code, obj = {}} = await this.$http('smarthos.referral.order.details', data);
        return code === '0' ? obj : {};
    }

    /***
     *  取消申请
     */
    async cancleApply(data) {
        const {code} = await this.$http('smarthos.referral.order.cancel', data);
        return code === '0'
    }

    /***
     *  更新资料
     */
    async loadAtt(data) {
        return await this.$http('smarthos.referral.order.perfect', data);
    }

    /*
    *  拒绝会诊
    *
    * **/
    async refuse(data){
        const {code}  = await this.$http('smarthos.referral.order.refused',data);
        return code === '0'
    }

    /***
     *  确认会诊申请
     *
     */
    async affirm(data){
        const {code}  = await this.$http('smarthos.referral.order.process',data);
        return code === '0'
    }

    /***
     *  修改会诊时间
     *
     */
    async update(data){
        const {code}  = await this.$http('smarthos.referral.order.refused',data);
        return code === '0'
    }

    /***
     *  转诊统计
     */
    async statictics(data){
        const {code,list=[],page}  = await this.$http('smarthos.referral.order.list',data);
        return code === '0' ? {list,page} : {list:[],page}
    }

    /***
     *  根据就诊卡号进行搜索信息
     */
    async searchByCard(data){
       return  await this.$http('smarthos.yygh.ApiPatientService.selectHosPatInfo',data);
    }

    /***
     * 上传base64图片代码
     */
    async loadBase(data){
       return   await this.$http('smarthos.system.file.upload.image.base64',data);
    }

    /***
     *  挂号预约补充资料接口
     */
    async supplement(data){
        return  await this.$http('smarthos.online.remoteoutpatient.supplement',data);
    }
}

export const hosService = new HosService();